export default "__VITE_ASSET__BdDqFhTc__"